import { FilterOptionKeys } from '@griply/types';
import { priorityFilterOptions } from '@griply/utils';
import { TFunction } from 'i18next';
import { Warning } from 'shared/assets/icons';
import { FilterOptionType, FilterSelectOption } from 'shared/types/filter';
import { TaskPriorityOptions } from 'shared/types/task-base';

export type Options = {
  t: TFunction;
};

const priorityLabelKeys: Record<TaskPriorityOptions, string> = {
  [TaskPriorityOptions.High]:
    'context-menus.filtering.task.filters.priority.options.high',
  [TaskPriorityOptions.Medium]:
    'context-menus.filtering.task.filters.priority.options.medium',
  [TaskPriorityOptions.Low]:
    'context-menus.filtering.task.filters.priority.options.low',
  [TaskPriorityOptions.None]:
    'context-menus.filtering.task.filters.priority.options.none',
};

export const createPriorityFilter = ({ t }: Options): FilterSelectOption => ({
  id: FilterOptionKeys.Priority,
  label: t('general.filters.title.priority'),
  placeholder: t('general.labels.select'),
  icon: Warning,
  type: FilterOptionType.MultiSelect,
  selectOptions: priorityFilterOptions.map((value) => ({
    label: t(priorityLabelKeys[value]),
    value,
  })),
  canReset: true,
});
